import { memo } from "react";

function StatusCardSkeleton() {
  return (
    <div className="p-2 w-full md:w-[22%] card-base animate-pulse">
      <div className="flex flex-col items-start space-y-1">
        {/* Top Row: Icon + Value */}
        <div className="flex w-full justify-between items-center">
          <div className="p-2 rounded-lg bg-gray-200">
            <div className="w-3 h-3 bg-gray-200 rounded" />
          </div>
          <div className="w-4 h-4 bg-gray-200 rounded mr-3" />
        </div>

        {/* Label */}
        <div className="w-16 h-3 bg-gray-200 rounded mt-2" />

        {/* Change Text */}
        <div className="w-10 h-2 bg-gray-200 rounded mt-1" />
      </div>
    </div>
  );
}
 export default memo(StatusCardSkeleton);